/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import {Button, Input} from 'antd'

import './Calculator.less'
import Icon from '../Icon'
import Price from "../Icon/img/Price";
import Line from "../Icon/img/Line";
import Banknote from "../Icon/img/Banknote";

let acc = require('accounting')

const calculatorsData = {
  CPA: {
    line_1: 'Current Average CPC',
    line_2: 'Average Site Conversion Rate',
    line_3: 'Target Acquisition Cost',
    line_4: 'Calculated Acquisition Cost',
    title_y: 'CPC',
    title_x: 'Conversion Rate %',
  },
}

 const INITIAL_STATE = {
    CPA: {
      value_1: 0.45,
      value_2: acc.formatNumber(2.9, 2, '.') + '%',
      value_3: acc.formatNumber(15, 2, '.'),
      result: 0.45 / (2.9 / 100),
      arrValue_1: [],
      arrValue_2: [],
    },
  }

function Calculator(props) {
  const {calculator} = props

  const [state, setState] = useState({
    CPA: {
      value_1: 0.45,
      value_2: acc.formatNumber(2.9, 2, '.') + '%',
      value_3: acc.formatNumber(15, 2, '.'),
      result: 0.45 / (2.9 / 100),
      arrValue_1: [],
      arrValue_2: [],
    }
  })

  const {value_1, value_2, value_3, result, arrValue_1, arrValue_2} = state[calculator]

  useEffect(() => {
    if ((value_1 <= 0 || value_2.slice(0, -1) <= 0) && result) {
      setState({...state, [calculator]: {...state[calculator], result: null}})
    }
    if (value_1 > 0 && value_2.slice(0, -1) > 0) {
      let newResult = getResult(value_1, value_2.slice(0, -1))
      setState({...state, [calculator]: {...state[calculator], result: newResult}})
    }
  }, [state[calculator].value_1, state[calculator].value_2])

  useEffect(() => {
    if (!result) return
    let newArrValue_1
    let newArrValue_2

    if (calculator === 'CPA') {
      newArrValue_1 = new Array(11).fill(1).map((el, index) => Math.floor(el * value_1 * (1.5 - 0.1 * index) * 100) / 100)
      newArrValue_2 = [0.59049, 0.6561, 0.729, 0.81, 0.9, 1, 1.1, 1.21, 1.331, 1.4641, 1.61051].map(
        el => Math.floor(el * value_2.slice(0, -1) * 100) / 100,
      )
    } else {
      newArrValue_1 = new Array(11)
        .fill(1)
        .map((el, index) => Math.floor(el * value_1 * (1.5 - 0.1 * index) * 100) / 100)
        .reverse()
      newArrValue_2 = [0.59049, 0.6561, 0.729, 0.81, 0.9, 1, 1.1, 1.21, 1.331, 1.4641, 1.61051]
        .map(el => Math.floor(el * value_2.slice(0, -1) * 100) / 100)
        .reverse()
    }

    setState({
      ...state,
      [calculator]: {...state[calculator], arrValue_1: [...newArrValue_1], arrValue_2: [...newArrValue_2]},
    })
  }, [state[calculator].result, state[calculator].value_3])

  const getResult = (val_1, val_2) => {
    let result
    if (calculator === 'CPA') result = val_1 / (val_2 / 100)
    if (calculator === 'ROAS') result = val_2 / val_1
    if (calculator === 'BEROAS') {
      if (val_1 === val_2) {
        result = 0
      } else {
        result = val_1 / (val_1 - val_2)
      }
    }

    return result
  }

  function handleChange(event) {
    const {name, value} = event.target
    const reg = /^-?\d*(\.\d*)?$/
    if ((!isNaN(value) && reg.test(value)) || value === '') {
      if (calculator === 'CPA' && name === 'value_2' && value > 100) return
      setState({...state, [calculator]: {...state[calculator], [name]: value}})
    }
  }

  function handleClear() {
    if (
      state[calculator].value_1 !== INITIAL_STATE[calculator].value_1 ||
      state[calculator].value_2 !== INITIAL_STATE[calculator].value_2 ||
      state[calculator].value_3 !== INITIAL_STATE[calculator].value_3
    ) {
      setState({...state, [calculator]: {...INITIAL_STATE[calculator]}})
    }
  }

  const EmptyTable = (
    <>
      {['', '', '', '', '', '', '', '', '', '', ''].map((y, index) => (
        <div key={'line_' + index} className='line'>
          <div className={`cell`} />
          {['', '', '', '', '', '', '', '', '', '', ''].map((x, i) => (
            <div key={'cell_' + index + '_' + i} className={`cell`} />
          ))}
        </div>
      ))}
      <div className='line'>
        <div className='cell empty' />
        {['', '', '', '', '', '', '', '', '', '', ''].map((x, i) => (
          <div key={'total_' + i} className={`cell`} />
        ))}
      </div>
    </>
  )

  return (
    <div className={`calculator`}>
      <div className='info-block'>
        <div className='calculator-block'>
          <div className='calculator-block-item'>
            <span>{calculatorsData[calculator].line_1}</span>
            <Input
                className='calculator-input'
                prefix={<Price />}
                name={'value_1'}
                value={value_1}
                onChange={handleChange}
                autoComplete='off'
                onBlur={e => setState({...state, [calculator]: {...state[calculator], [e.target.name]: acc.formatNumber(e.target.value, 2, '.')}})}
            />
          </div>
          <div className='calculator-block-item'>
            <span>{calculatorsData[calculator].line_2}</span>
            <Input
              className='calculator-input'
              prefix={<Price />}
              name={'value_2'}
              value={value_2}
              onChange={handleChange}
              autoComplete='off'
              onFocus={e => setState({...state, [calculator]: {...state[calculator], [e.target.name]: e.target.value.slice(0,-1)}})}
              onBlur={e => setState({...state, [calculator]: {...state[calculator], [e.target.name]: acc.formatNumber(e.target.value, 2, '.') + '%'}})}

            />
          </div>
          <div className='calculator-block-item'>
            <span>{calculatorsData[calculator].line_3}</span>
            <Input
                className='calculator-input'
                name={'value_3'}
                value={value_3}
                onChange={handleChange}
                prefix={calculator === 'ROAS' ? <Line /> : calculator === 'BEROAS' ? <Banknote /> : <Price />}
                autoComplete='off'
                onBlur={e => setState({...state, [calculator]: {...state[calculator], [e.target.name]: acc.formatNumber(e.target.value, 2, '.')}})}
            />
          </div>
          <div className='calculator-block-item total'>
            <span>{calculatorsData[calculator].line_4}</span>
            <div className='result'>
              {calculator === 'ROAS' ? <Line inverse={true} /> : calculator === 'BEROAS' ? <Banknote inverse={true} /> : <Price inverse={true} />}
              <span>{acc.formatNumber(result, 2, '.')}</span>
            </div>
            <Button
                className='clear-btn'
                onClick={handleClear}
            >
              <Icon type='undo' role='icon' />
            </Button>
          </div>
        </div>
      </div>

      <div className='body'>
        {result !== null ? (
          <>
            {arrValue_1.map((y) => (
              <div key={'line_' + y} className='line'>
                <div className={`cell${y > 0 && y === +value_1 ? ' active' : ''}`}>{acc.formatNumber(y, 2, '.')}</div>
                {arrValue_2.map(x => (
                  <div
                    key={'cell_' + y + '_' + x}
                    className={`cell${
                      // value_3 ? (Math.floor((getResult(y, x) + 0.000000001) * 100) / 100 >= +value_3 ? ' down' : ' up') : ''
                      value_3 ? (acc.formatNumber(getResult(y, x), 2, '') > +value_3 ? ' down' : ' up') : ''
                    }`}
                  >
                    {acc.formatNumber(getResult(y, x), 2, '')}
                  </div>
                ))}
              </div>
            ))}

            <div className='line'>
              <div className='cell empty' />
              {arrValue_2.map(x => (
                <div key={'total_' + x} className={`cell${x > 0 && x === +value_2.slice(0,-1) ? ' active' : ''}`}>
                  {acc.formatNumber(x, 2, ' ')}
                  {calculator === 'CPA' ? '%' : ''}
                </div>
              ))}
            </div>
          </>
        ) : (
          EmptyTable
        )}
        <span className='axis axis-y'>{calculatorsData[calculator].title_y}</span>
        <span className='axis axis-x'>{calculatorsData[calculator].title_x}</span>
      </div>
    </div>
  )
}

export default Calculator
